import type { IconData } from '@stacksjs/iconify-core'

export const openUmbrellaSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21.988 2.671c.829-1.658 3.196-1.658 4.025 0l1.202 2.405c5.062.772 9.55 3.299 12.91 6.575c3.525 3.438 5.917 7.81 6.351 12.047c.133 1.295-.425 2.649-1.686 3.362c-2.125 1.202-7.158 3.118-17.98 3.404l.19 8.26C27 43.294 23.418 47 19 47s-8-3.705-8-8.276v-.76c0-1.122.65-2.137 1.763-2.272c.358-.043.77-.071 1.237-.071s.88.028 1.237.071c1.114.135 1.763 1.15 1.763 2.272v.76c0 1.143.896 2.07 2 2.07s2-.927 2-2.07l.19-8.26c-10.82-.286-15.854-2.202-17.98-3.404c-1.26-.713-1.818-2.067-1.685-3.362c.434-4.237 2.825-8.609 6.35-12.047c3.36-3.276 7.848-5.803 12.91-6.575z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default openUmbrellaSolid
